<template>
  <main class="ca-wrap">
    <div class="ca-inner">

      <!-- 헤더 -->
      <div class="ca-header">
        <div class="ca-header-badge">💬 1:1 문의</div>
        <h1 class="ca-title">무엇이든 물어보세요</h1>
        <p class="ca-sub">담당 직원이 확인 후 빠르게 답변드립니다<br>
          <span class="ca-kakao">카카오톡 플러스친구로 문의하시면 더욱 빠른 답변을 받으실 수 있어요</span>
        </p>
      </div>

      <!-- 폼 카드 -->
      <div class="ca-card">

        <!-- 문의확인 안내 -->
        <div class="ca-notice">
          <i class="bi bi-info-circle-fill"></i>
          문의 확인은 <strong>마이페이지 &gt; 1:1문의</strong>에서 하실 수 있습니다.
        </div>

        <!-- 연결된 예약번호 (호텔/엔버스/일반상품 상세에서 진입 시) -->
        <div class="ca-linked-res" v-if="bookId">
          <i class="bi bi-link-45deg"></i>
          <span>연결된 예약번호</span>
          <strong>{{ bookId }}</strong>
        </div>

        <!-- ① 문의유형 -->
        <div class="ca-field">
          <label class="ca-label">문의유형 <span class="ca-req">*</span></label>
          <select class="ca-select" ref="sel_selCat" v-model="reqInfo.selCat">
            <option :value="noVal" disabled>문의유형을 선택해주세요</option>
            <option :value="cl.baseCode" :key="i" v-for="(cl, i) in inquiryCatList">
              {{ cl.codeNameKor }}
            </option>
          </select>
        </div>

        <!-- ② 제목 -->
        <div class="ca-field">
          <label class="ca-label">제목 <span class="ca-req">*</span></label>
          <input type="text" maxlength="22" class="ca-input"
            placeholder="문의 제목을 입력해주세요"
            ref="txt_reqTitle" v-model="reqInfo.reqTitle" />
        </div>

        <!-- ③ 이름 + 여행지역 -->
        <div class="ca-row">
          <div class="ca-field ca-field-half">
            <label class="ca-label">성명 <span class="ca-req">*</span></label>
            <input type="text" maxlength="12" class="ca-input"
              placeholder="성명을 입력해주세요"
              ref="txt_reqPersonName" v-model="reqName" />
          </div>
          <div class="ca-field ca-field-half">
            <label class="ca-label">여행지역</label>
            <select class="ca-select" ref="sel_Nat" v-model="reqInfo.selNat">
              <option :value="noVal" disabled>여행지역 선택</option>
              <option :value="nl.baseCode" :key="i" v-for="(nl, i) in nationList">
                {{ nl.codeNameKor }}
              </option>
            </select>
          </div>
        </div>

        <!-- ④ 이메일 + 연락처 -->
        <div class="ca-row">
          <div class="ca-field ca-field-half">
            <label class="ca-label">이메일 <span class="ca-req">*</span></label>
            <input type="email" maxlength="40" class="ca-input"
              placeholder="이메일을 입력해주세요"
              ref="txt_cEmail" v-model="reqInfo.reqEmail" />
          </div>
          <div class="ca-field ca-field-half">
            <label class="ca-label">연락처 <span class="ca-req">*</span></label>
            <input type="text" maxlength="11" class="ca-input"
              placeholder="숫자만 입력 (01012345678)"
              ref="txt_cTel" v-model="reqTel" />
          </div>
        </div>

        <!-- ⑤ 문의내용 -->
        <div class="ca-field">
          <label class="ca-label">문의내용 <span class="ca-req">*</span></label>
          <textarea class="ca-textarea" maxlength="248"
            placeholder="문의하실 내용을 입력해주세요 (250자 이내)"
            ref="txt_reqSpRemarks" v-model="reqInfo.reqSpRemarks" />
          <div class="ca-textarea-count">{{ (reqInfo.reqSpRemarks || '').length }} / 248</div>
        </div>

        <!-- ⑥ 개인정보 동의 -->
        <div class="ca-agree">
          <label class="ca-agree-label">
            <input type="checkbox" v-model="ruleAgree" ref="chb_ruleAgree" class="ca-checkbox" />
            <span><span class="ca-req">[필수]</span> 개인정보 수집 및 이용동의</span>
          </label>
          <button class="ca-agree-detail" @click="isModalOpen = true">전체보기</button>
        </div>

        <!-- ⑦ 버튼 -->
        <div class="ca-btns">
          <button class="ca-btn ca-btn-cancel" @click="goToHome()">
            취소
          </button>
          <button class="ca-btn ca-btn-submit" @click="requestInsert()">
            <i class="bi bi-send"></i> 문의 등록
          </button>
        </div>

      </div>
    </div>

    <!-- 개인정보 모달 -->
    <div class="ca-modal-overlay" v-if="isModalOpen" @click.self="isModalOpen = false">
      <div class="ca-modal">
        <div class="ca-modal-header">
          <span>개인정보 수집 및 이용 동의</span>
          <button class="ca-modal-close" @click="isModalOpen = false">✕</button>
        </div>
        <div class="ca-modal-body">
          <p>엔타비 글로벌(이하 '엔타비')는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.</p>

          <h4>1. 개인정보 수집 및 이용목적</h4>
          <p>엔타비는 개인정보를 다음의 목적을 위해 처리합니다.</p>
          <ul>
            <li>홈페이지 회원가입 및 관리: 회원 가입의사 확인, 본인 식별·인증, 회원자격 유지·관리 등</li>
            <li>서비스 제공: 물품배송, 서비스 제공, 청구서 발송, 콘텐츠 제공 등</li>
            <li>마케팅 및 광고 활용: 신규 서비스 개발, 이벤트 및 광고성 정보 제공 등</li>
          </ul>

          <h4>2. 개인정보 수집 항목</h4>
          <ul>
            <li>회원가입/관리: 이메일, 휴대전화번호, 비밀번호, 로그인ID, 성별, 생년월일, 이름</li>
            <li>상담 및 여행 예약: 이메일, 휴대전화번호, 이름, 여권사본 등</li>
            <li>대금결제: 신용카드정보, 은행계좌정보</li>
          </ul>

          <h4>3. 개인정보 보유 및 이용기간</h4>
          <ul>
            <li>신용정보 수집/처리 기록: 3년</li>
            <li>소비자 불만 또는 분쟁처리 기록: 3년</li>
            <li>대금결제 및 재화 공급 기록: 5년</li>
            <li>계약 또는 청약철회 기록: 5년</li>
            <li>표시/광고 기록: 6개월</li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false,
      ruleAgree: false,
      nationList: [],
      inquiryCatList: [],
      reqInfo: {
        selCat: 'noVal',
        selNat: 'noVal',
        reqTitle: '',
        reqEmail: '',
        reqSpRemarks: '',
      },
      reqName: '',
      reqTel: '',
      noVal: 'noVal',

      // ── 예약 연결 정보 (tb_customerask 컬럼명에 맞춤) ──
      bookId: '',     // book_id 컬럼용
      ctCode: '',     // ctCode 컬럼용
      pdtCode: '',    // pdtCode 컬럼용
    };
  },

  created() {
    if (this.$store.state.user.handlerId != undefined) 
    {
      this.user = this.$store.state.user.handlerId
    } 
    else if (this.$store.state.user.email != undefined) 
    {
      this.user = this.$store.state.user.email
    } 
    else 
    {
      this.user = ""
    }

    // ── 예약 연결 파라미터 수신 ──
    this.bookId = this.$route.query.bookId || ''
    this.ctCode = this.$route.query.ctCode || ''
    this.pdtCode = this.$route.query.pCode || ''

    if (this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.user.joinFlag === "H" || this.user.joinFlag === "M") 
    {
      this.k_name = (!this.user.nickname) ? "" : this.user.nickname;
      let kakaoPhone = ""
      if (this.user.alimCallC != undefined && this.user.alimCallC.charAt(0) === '+') {
        kakaoPhone = this.user.alimCallC.replace("+82 ", "0")
      } else {
        kakaoPhone = this.user.alimCallC
      }
      this.k_tel = (!this.user.alimCallC) ? "" : kakaoPhone.replace(/-/g, "");
    } else {
      this.k_name = this.user.name;
      this.k_tel = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g, "");
    }

    this.reqName = this.k_name
    this.reqTel  = this.k_tel

    this.getInquiryCatList();
    this.getNationList();
  },

  computed: {
    user() { return this.$store.state.user; }
  },

  mounted() {
    if (document.referrer == "") 
    {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/");
    }

    if (!this.$store.state.user.email || this.$store.state.user.email == undefined) 
    {
      var swal = require('sweetalert2');
      swal.fire({ title: '', text: '로그인 후 이용해주세요.', icon: 'warning' });
      this.$router.push({ path: '/b2CLogin', query: { st: "Y" } });
    }
  },

  methods: {
    async getNationList() {
      let nationList = await this.$api("/api/searchBasecode", { param: ['ntCd'] });
      if (nationList.length > 0) this.nationList = nationList;
    },

    async getInquiryCatList() {
      let inquiryCatList = await this.$api("/api/searchBasecode", { param: ['iqCd'] });
      if (inquiryCatList.length > 0) this.inquiryCatList = inquiryCatList;
    },

    async requestInsert() {
      let date      = new Date(+new Date() + 3240 * 10000).toISOString().split("T")[0]
      let today     = new Date()
      let timeStamp = today.getTime()
      let askCode   = 'CA-' + date + timeStamp

      if (!this.ruleAgree) 
      {
        this.$refs.chb_ruleAgree.focus();
        this.$swal.fire("", "필수 개인정보 동의를 해주십시오.", "warning");
        return false;
      }
      if (this.reqInfo.selCat == "noVal" || this.reqInfo.selCat == undefined) 
      {
        this.$refs.sel_selCat.focus();
        this.$swal.fire("", "문의유형을 선택해주세요.", "warning");
        return false;
      }
      if (!this.reqInfo.reqTitle) 
      {
        this.$refs.txt_reqTitle.focus();
        return this.$swal.fire("", "제목을 입력해주세요.", "warning");
      }
      if (!this.reqName) 
      {
        this.$refs.txt_reqPersonName.focus();
        this.$swal.fire("", "성명을 입력해주세요.", "warning");
        return false;
      }
      if (!this.reqInfo.reqEmail) 
      {
        this.$refs.txt_cEmail.focus();
        this.$swal.fire("", "이메일을 입력해주세요.", "warning");
        return false;
      }
      if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/.test(this.reqInfo.reqEmail)) 
      {
        this.$refs.txt_cEmail.focus();
        this.$swal.fire('', '이메일 형식이 올바르지 않습니다.', 'question');
        return false;
      }
      if (!this.reqTel) 
      {
        this.$refs.txt_cTel.focus();
        this.$swal.fire("", "연락처를 입력해주세요.", "warning");
        return false;
      }
      if (!/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}/.test(this.reqTel)) 
      {
        this.$refs.txt_cTel.focus();
        this.$swal.fire('', '연락처 형식이 올바르지 않습니다.', 'question');
        return false;
      }
      if (!this.reqInfo.reqSpRemarks) 
      {
        this.$refs.txt_reqSpRemarks.focus();
        this.$swal.fire("", "문의 내용을 입력해주세요.", "warning");
        return false;
      }

      this.reqInfo.insDate   = today;
      this.reqInfo.reqStatus = "IQ";

      let resIns_Request = await this.$api("/api/ins_customerAsk", {
        param: [
          this.reqInfo.selCat, this.reqInfo.reqTitle, this.reqName,
          this.reqInfo.selNat, this.reqInfo.reqEmail, this.reqTel,
          this.reqInfo.reqSpRemarks, this.ruleAgree, this.reqInfo.reqStatus,
          this.user.email, askCode,
          this.bookId, this.ctCode, this.pdtCode
        ]
      });

      if (resIns_Request.affectedRows <= 0) 
      {
        this.$swal.fire('', '문의 등록 중 오류가 발생했습니다.<br>연속 오류 시 연락처 (1660-4602)', 'error')
      } 
      else 
      {
        this.$swal.fire('', '문의가 등록되었습니다.<br>빠른 시간 내에 답변드리겠습니다.', 'success');
        this.$router.push({ path: '/' });
      }
    },

    goToHome() {
      this.$router.push({ path: '/myPage' });
    }
  }
}
</script>

<style scoped>
/* ── 변수 ── */
.ca-wrap {
  --green:       #86cd53;
  --green-dark:  #5fa033;
  --charcoal:    #2b3a2b;
  --bg:          #f5faf2;
  --border:      #ddefd4;
  --white:       #ffffff;
  --text-main:   #1a2e1a;
  --text-sub:    #5a7a5a;
  --text-muted:  #8aaa8a;
  --red:         #e53935;
  --radius:      14px;
  --radius-sm:   8px;

  background: var(--bg);
  min-height: 100vh;
  padding: 3rem 1rem 5rem;
  font-family: 'Noto Sans KR', sans-serif;
}

.ca-inner {
  max-width: 640px;
  margin: 0 auto;
}

/* ── 헤더 ── */
.ca-header {
  text-align: center;
  margin-bottom: 2rem;
}
.ca-header-badge {
  display: inline-block;
  background: #d4f0b8;
  color: var(--green-dark);
  font-size: .75rem;
  font-weight: 700;
  letter-spacing: .1em;
  padding: .28rem 1rem;
  border-radius: 20px;
  margin-bottom: .8rem;
}
.ca-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--charcoal);
  margin: 0 0 .5rem;
}
.ca-sub {
  font-size: .88rem;
  color: var(--text-sub);
  line-height: 1.7;
  margin: 0;
}
.ca-kakao {
  font-size: .78rem;
  color: var(--text-muted);
}

/* ── 카드 ── */
.ca-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: 0 4px 24px rgba(90,160,51,.08);
  padding: 2rem;
}
@media (max-width: 600px) {
  .ca-card { padding: 1.4rem; }
}

/* ── 안내 박스 ── */
.ca-notice {
  display: flex;
  align-items: center;
  gap: .5rem;
  background: #f0fbe7;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: .75rem 1rem;
  font-size: .82rem;
  color: var(--text-sub);
  margin-bottom: 1.8rem;
}
.ca-notice i { color: var(--green-dark); font-size: 1rem; flex-shrink: 0; }
.ca-notice strong { color: var(--charcoal); }

/* ── 필드 ── */
.ca-field {
  margin-bottom: 1.3rem;
  position: relative;
}
.ca-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 600px) {
  .ca-row { grid-template-columns: 1fr; }
}
.ca-label {
  display: block;
  font-size: .78rem;
  font-weight: 700;
  color: var(--text-sub);
  text-transform: uppercase;
  letter-spacing: .04em;
  margin-bottom: .45rem;
}
.ca-req {
  color: var(--red);
  margin-left: .1rem;
}
.ca-input,
.ca-select,
.ca-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: .75rem 1rem;
  border: 1.5px solid #d4e6c3;
  border-radius: var(--radius-sm);
  font-size: .9rem;
  color: var(--text-main);
  background: #fff;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
  font-family: inherit;
}
.ca-input:focus,
.ca-select:focus,
.ca-textarea:focus {
  border-color: var(--green);
  box-shadow: 0 0 0 3px rgba(134,205,83,.15);
}
.ca-select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%235a7a5a' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 2.5rem;
  cursor: pointer;
}
.ca-textarea {
  min-height: 150px;
  resize: vertical;
  line-height: 1.6;
}
.ca-textarea-count {
  text-align: right;
  font-size: .72rem;
  color: var(--text-muted);
  margin-top: .3rem;
}

/* ── 약관 동의 ── */
.ca-agree {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fdf4;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: .9rem 1rem;
  margin-bottom: 1.8rem;
}
.ca-agree-label {
  display: flex;
  align-items: center;
  gap: .6rem;
  font-size: .85rem;
  color: var(--text-main);
  cursor: pointer;
}
.ca-checkbox {
  width: 17px;
  height: 17px;
  accent-color: var(--green-dark);
  cursor: pointer;
  flex-shrink: 0;
}
.ca-agree-detail {
  font-size: .75rem;
  font-weight: 600;
  color: var(--green-dark);
  background: none;
  border: 1px solid var(--green-dark);
  border-radius: 20px;
  padding: .2rem .75rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all .15s;
}
.ca-agree-detail:hover {
  background: var(--green-dark);
  color: #fff;
}

/* ── 버튼 ── */
.ca-btns {
  display: flex;
  gap: .8rem;
}
.ca-btn {
  flex: 1;
  padding: .9rem;
  font-size: .95rem;
  font-weight: 700;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all .2s;
  font-family: inherit;
}
.ca-btn-cancel {
  background: #f0f4f0;
  color: var(--text-sub);
  border: 1px solid var(--border);
}
.ca-btn-cancel:hover { background: #e4ede4; }
.ca-btn-submit {
  background: var(--charcoal);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .4rem;
}
.ca-btn-submit:hover { background: var(--green-dark); }

/* ── 모달 ── */
.ca-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}
.ca-modal {
  background: var(--white);
  border-radius: var(--radius);
  width: 100%;
  max-width: 520px;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0,0,0,.2);
}
.ca-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 1.5rem;
  border-bottom: 1px solid var(--border);
  font-size: 1rem;
  font-weight: 700;
  color: var(--charcoal);
}
.ca-modal-close {
  background: none;
  border: none;
  font-size: 1.1rem;
  color: var(--text-muted);
  cursor: pointer;
  padding: .2rem .4rem;
  border-radius: 4px;
  transition: all .15s;
}
.ca-modal-close:hover { background: #f0f0f0; color: var(--text-main); }
.ca-modal-body {
  padding: 1.5rem;
  overflow-y: auto;
  font-size: .85rem;
  color: var(--text-sub);
  line-height: 1.8;
}
.ca-modal-body h4 {
  font-size: .9rem;
  font-weight: 700;
  color: var(--charcoal);
  margin: 1.2rem 0 .4rem;
}
.ca-modal-body ul {
  padding-left: 1.2rem;
  margin: 0 0 .5rem;
}
.ca-modal-body p {
  margin: 0 0 .5rem;
}

.ca-linked-res {
  display: flex;
  align-items: center;
  gap: .5rem;
  background: #eef6ff;
  border: 1px solid #cfe4fb;
  border-radius: var(--radius-sm);
  padding: .65rem 1rem;
  font-size: .82rem;
  color: #1565c0;
  margin-bottom: 1.3rem;
}
.ca-linked-res strong { font-weight: 700; }
</style>